import React from 'react';
import '../list/ListSymbols.css';
import Tooltip from '../tooltip/Tooltip';

const DEADLINE_MS = 48 * 60 * 60 * 1000; // 48 Stunden in Millisekunden
const HALF_DEADLINE_MS = 24 * 60 * 60 * 1000; // 24 Stunden in Millisekunden

// scale(s) translate(t,t) zentriert den Inhalt bei s: t = 10*(1/s - 1)
const SCALE = 0.82;
const TRANSLATE = 10 * (1 / SCALE - 1);
const G_TRANSFORM = `scale(${SCALE}) translate(${TRANSLATE} ${TRANSLATE})`;

// sentAt: Date | null
// null  → keine Mail versendet (Zustand 1)
// Date  → Mail versendet, Frist läuft oder abgelaufen (Zustand 2/3)
// tooltip (optional): Erklärung beim Hover — in der Teilnehmerliste gesetzt, in der Legende nicht.
function WaitlistStatusIcon({ sentAt = null, tooltip }) {
  const icon = renderStatusIcon(sentAt);
  return tooltip ? <Tooltip text={tooltip}>{icon}</Tooltip> : icon;
}

function renderStatusIcon(sentAt) {
  if (!sentAt) {
    return (
      <svg className="waitlistStatusIcon" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g transform={G_TRANSFORM}>
          <circle cx="10" cy="10" r="8.5" stroke="var(--positive-hover-color)" strokeWidth="2.5" />
          <rect x="7" y="6" width="2" height="8" rx="1" fill="var(--positive-hover-color)" />
          <rect x="11" y="6" width="2" height="8" rx="1" fill="var(--positive-hover-color)" />
        </g>
      </svg>
    );
  }

  const elapsed = Date.now() - new Date(sentAt).getTime();

  if (elapsed >= DEADLINE_MS) {
    return (
      <svg className="waitlistStatusIcon" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g transform={G_TRANSFORM}>
          <circle cx="10" cy="10" r="8.5" stroke="var(--negative-color)" strokeWidth="2.5" />
          <rect x="9.2" y="5.5" width="1.6" height="6" rx="0.8" fill="var(--negative-color)" />
          <circle cx="10" cy="14.5" r="1" fill="var(--negative-color)" />
        </g>
      </svg>
    );
  }

  const fraction = Math.max(0, 1 - elapsed / DEADLINE_MS);
  const color = elapsed >= HALF_DEADLINE_MS ? 'var(--warning-color)' : 'var(--accent-color)';
  const innerR = 3;
  const circumference = 2 * Math.PI * innerR;

  return (
    <svg className="waitlistStatusIcon" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g transform={G_TRANSFORM}>
        <circle cx="10" cy="10" r="8.5" stroke={color} strokeWidth="2.5" />
        <circle
          cx="10" cy="10" r={innerR}
          fill="none"
          stroke={color}
          strokeWidth={innerR * 2}
          strokeLinecap="butt"
          strokeDasharray={`${fraction * circumference} ${circumference}`}
          transform="rotate(-90 10 10)"
        />
      </g>
    </svg>
  );
}

export default WaitlistStatusIcon;
